import { render, staticRenderFns } from "./AccountActivationView.vue?vue&type=template&id=ef67b78a&scoped=true"
import script from "./AccountActivationView.vue?vue&type=script&lang=js"
export * from "./AccountActivationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef67b78a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef67b78a')) {
      api.createRecord('ef67b78a', component.options)
    } else {
      api.reload('ef67b78a', component.options)
    }
    module.hot.accept("./AccountActivationView.vue?vue&type=template&id=ef67b78a&scoped=true", function () {
      api.rerender('ef67b78a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/AccountActivationView.vue"
export default component.exports